var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DEFAULT_MULTIVALUE_SEPARATOR } from '../dataTable/types';
export var isPartialMatch = function (filterKeyword) {
    return function (item) { return item.name.toLowerCase().includes(filterKeyword.toLowerCase()); };
};
export var isExactMatch = function (filterKeyword) {
    return function (item) { return item.name.toLowerCase() === filterKeyword.toLowerCase(); };
};
export var isNotExactMatch = function (filterKeyword) {
    return function (item) { return item.name.toLowerCase() !== filterKeyword.toLowerCase(); };
};
export var isPartialOrChecked = function (item) { return item.checkboxState === 'CHECKED' || item.checkboxState === 'PARTIALLY_CHECKED'; };
export var nextCheckboxState = function (current) {
    switch (current) {
        case 'CHECKED': return 'UNCHECKED';
        case 'UNCHECKED': return 'CHECKED';
        case 'PARTIALLY_CHECKED': return 'UNCHECKED';
        default: return 'UNCHECKED';
    }
};
export var toggleItemCheckboxState = function (items, itemId) {
    return items.map(function (item) { return item.id === itemId
        ? __assign(__assign({}, item), { checkboxState: nextCheckboxState(item.checkboxState) }) : __assign(__assign({}, item), { children: item.children && toggleItemCheckboxState(item.children, itemId) }); });
};
export var areAllItemsSelected = function (items) {
    return items.every(function (item) { return isPartialOrChecked(item) && (!item.children || areAllItemsSelected(item.children)); });
};
export var setCheckboxStateForItems = function (items, checkboxState) {
    return items.map(function (item) { return (__assign(__assign({}, item), { checkboxState: checkboxState, children: item.children && setCheckboxStateForItems(item.children, checkboxState) })); });
};
export var flattenItems = function (items) {
    return items
        .map(function (item) { return __spreadArray([item], (item.children ? flattenItems(item.children) : []), true); })
        .reduce(function (acc, val) { return acc.concat(val); }, []);
};
export var checkedItemNamesConcatenated = function (items) {
    return flattenItems(items)
        .filter(isPartialOrChecked)
        .map(function (item) { return item.name; })
        .join(DEFAULT_MULTIVALUE_SEPARATOR);
};
export var filterItems = function (filterPredicate, items) {
    if (!!items) {
        return items
            .map(function (item) { return (__assign(__assign({}, item), { children: filterItems(filterPredicate, item.children) })); })
            .filter(function (item) { return filterPredicate(item) || (item.children && item.children.length > 0); });
    }
    return items;
};
export var filterExactMatch = function (filteredKeyword, items) {
    if (!!filteredKeyword && !!items) {
        return items.filter(isNotExactMatch(filteredKeyword));
    }
    return items;
};
export var filterNotExactMatch = function (filteredKeyword, items) {
    if (!!filteredKeyword && !!items) {
        return items.filter(isExactMatch(filteredKeyword));
    }
    return [];
};
//# sourceMappingURL=utils.js.map